import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { USER_URL } from "../../constant/api";

const AdminSpecialOfrer = () => {
  const navigate = useNavigate();
    const [filter, setFilter] = useState(null);
    const [loading, setLoading] = useState(false);
    const [errors, setErrors] = useState({});
    const [specialoffer, setSpecialOffer] = useState([])
 const [filteredOffers, setFilteredOffers] = useState([]);
  const filters = [
    { key: 1, label: "All", value: null },
    { key: 2, label: "One Day", value: "Daily" },
    { key: 3, label: "One Week", value: "Weekly" },
    { key: 4, label: "One Month", value: "Monthly" },
  ];
  
    const handleDelete = (id) => {
      console.log("Delete sponsor with ID:", id);
      try {
        setLoading(true);
        USER_URL.delete(`/products/admin/packages/${id}/`)
          .then((response) => {
            console.log("Sponsor deleted successfully:", response.data);
            toast.success("Sponsor package deleted successfully.");
            setSpecialOffer((prev) => prev.filter((sponsor) => sponsor.id !== id));
          })
          .catch((error) => {
            console.error("Error deleting sponsor:", error);
            toast.error("Error deleting sponsor package.");
          })
          .finally(() => {
            setLoading(false);
          });
        
      } catch (error) {
        console.error("Error deleting sponsor:", error);
        toast.error("Error deleting sponsor package.");
        
      }
    };

    useEffect(() => {
      const fetchData = async () => {
        try {
          setLoading(true);
          const response = await USER_URL.get("/products/admin/packages/?promotion_type=SpecialOffer")
          console.log("response special offer", response.data);
          setSpecialOffer(response.data.Data)
          setLoading(false);
        } catch (error) {
          console.log("error in fetch special offer", error);
          setLoading(false);
          toast.error("Error fetching special offer packages");
          
        }

      };
      fetchData();
    },[])
     // Re-filter whenever `filter` or `specialoffer` changes
      useEffect(() => {
        if (filter) {
          setFilteredOffers(specialoffer.filter((s) => s.period === filter));
        } else {
          setFilteredOffers(specialoffer);
        }
      }, [filter, specialoffer]);



      const handleStatusChange = (id, newStatus) => {
        setSpecialOffer((prev) =>
          prev.map((item) =>
            item.id === id ? { ...item, status: newStatus } : item
          )
        );
        toast.success(`Status updated to ${newStatus}`);
        // Optionally: call API to persist change
      };
  return (
    <div className="flex h-full w-full flex-col gap-4">
      <h2 className="text-3xl font-medium text-brand-primary text-center">Special Offer Packages</h2>

      <div className="flex justify-end">
        <button
          onClick={() => navigate("/admin/packages/specialoffer/add")}
          className="w-fit cursor-pointer rounded-md bg-brand-button-green-bg p-2 px-4 text-white hover:scale-105"
        >
          Add Sponsor Package
        </button>
      </div>
      <div className="flex w-full items-center justify-start">
        <div className="flex w-full items-center justify-around border-b bg-white p-2">
          {filters.map((f) => (
            <div
              key={f.key}
              onClick={() => setFilter(f.value)}
              className={`flex cursor-pointer items-center gap-1 ${
                filter === f.value ? "font-bold text-brand-button-green-bg" : ""
              }`}
            >
              {f.label}
            </div>
          ))}
        </div>
      </div>

      {filteredOffers.length > 0 ? (
        <div className="flex w-full flex-col">
          <div className="w-full">
            <div className="grid w-full grid-cols-[4rem,3fr,2fr,2fr,2fr,2fr,2fr] bg-white p-2 font-medium text-brand-button-green-bg">
              <div className="text-center">No</div>
              <div className="text-center">Package Name</div>
              <div className="text-center">Period</div>
              <div className="text-center">Duration</div>
              <div className="text-center">Charge</div>
              <div className="text-center">Status</div>
              <div className="text-center">Actions</div>
            </div>
          </div>
          <div className="mt-4">
            {filteredOffers.map((sponsor, index) => (
              <div
                key={sponsor.id}
                className="grid grid-cols-[4rem,3fr,2fr,2fr,2fr,2fr,2fr] items-center gap-2 p-2"
              >
                <div className="rounded border p-2 text-center">{index + 1}</div>
                <div className="line-clamp-1 rounded border p-2 text-center">
                  {sponsor.name}
                </div>
                <div className="line-clamp-1 rounded border p-2 text-center">
                  {sponsor.period}
                </div>
                <div className="line-clamp-1 rounded border p-2 text-center">
                  {sponsor.duration_days}
                </div>
                <div className="line-clamp-1 rounded border p-2 text-center">
                  ₹ {sponsor.price}
                </div>
 {/* <div className="rounded border p-2 text-center">{sponsor.status}</div> */}
 <select
                  value={sponsor.status}
                  onChange={(e) =>
                    handleStatusChange(sponsor.id, e.target.value)
                  }
                  className={`rounded border px-2 py-2 text-center ${
                    sponsor.status === "Listed"
                      ? "text-green-500"
                      : "text-red-500"
                  }`}
                >
                  <option value="Listed" className="text-green-500">
                    Listed
                  </option>
                  <option value="Unlisted" className="text-red-500">
                    Unlisted
                  </option>
                </select>
                <div className="flex justify-center gap-2">
                  <button
                    onClick={() => navigate(`/admin/packages/specialoffer/edit/${sponsor.id}`)}
                    className="rounded-md border border-blue-500 px-3 py-2 text-sm text-blue-500 hover:bg-blue-500 hover:text-white"
                  >
                    Edit
                  </button>
                  <button
                    onClick={() => handleDelete(sponsor.id)}
                    className="rounded-md border border-red-500 py-2 px-3 text-sm text-red-500 hover:bg-red-500 hover:text-white"
                  >
                    Delete
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      ) : (
        <div className="flex h-[90%] w-full flex-col items-center justify-center">
          <h2 className="mt-2 text-2xl font-medium">No Sponsor packages found</h2>
        </div>
      )}
    </div>
    
  );
};

export default AdminSpecialOfrer;
